var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37297 0 0 5.37297 0 12C0 18.6278 5.37297 24 12 24C18.6278 24 24 18.6285 24 12C24 5.37297 18.6277 0 12 0ZM12 21.75C6.61503 21.75 2.25004 17.385 2.25004 12C2.25004 6.61503 6.61503 2.25004 12 2.25004C17.385 2.25004 21.75 6.61503 21.75 12C21.75 17.385 17.385 21.75 12 21.75ZM12.0008 5.26273C11.1413 5.26273 10.491 5.71126 10.491 6.43574V13.0807C10.491 13.806 11.1412 14.253 12.0008 14.253C12.8393 14.253 13.5105 13.7872 13.5105 13.0807V6.43574C13.5105 5.72846 12.8393 5.26273 12.0008 5.26273ZM12.0008 15.75C11.175 15.75 10.503 16.422 10.503 17.2485C10.503 18.0735 11.175 18.7455 12.0008 18.7455C12.8265 18.7455 13.4978 18.0735 13.4978 17.2485C13.4977 16.422 12.8265 15.75 12.0008 15.75Z",
    fill: "#FC4D03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAttention);
export default __webpack_public_path__ + "static/media/alert-attention.bbbac0f9a88070d5f29ce5bc65ee07b6.svg";
export { ForwardRef as ReactComponent };